  (function () {
    // Maparea marime camera -> BTU (intern) + midpoint sq ft (pt total la 6 camere).
    // Clientul vede doar sq ft; BTU se foloseste intern pentru potrivirea unitatilor.
    var SIZES = [
      { v: '250-400 sq ft', btu: '9k', k: 9, mid: 325 },
      { v: '400-600 sq ft', btu: '12k', k: 12, mid: 500 },
      { v: '600-800 sq ft', btu: '18k', k: 18, mid: 700 },
      { v: '800-1,200 sq ft', btu: '24k', k: 24, mid: 1000 },
      { v: '1,200-1,550 sq ft', btu: '36k', k: 36, mid: 1375 }
    ];
    // Reguli client (DIY Multi-Zone): air handlers doar 9/12/18/24K; 36K => custom.
    var MULTI_MAX_K = 55;      // capacitatea celui mai mare condenser (55K / 6 zone)
    var MULTI_HANDLER_MAX = 24; // cea mai mare capacitate de air handler pt multi-zone
    function sizeInfo(v) { for (var i = 0; i < SIZES.length; i++) { if (SIZES[i].v === v) return SIZES[i]; } return null; }
    // Tipul camerei — doar etichetă (in mix + email); NU afecteaza matching-ul (BTU vine din sq ft).
    var TYPES = ['Bedroom', 'Living Area', 'Home Office', 'Garage', 'Basement', 'Other'];

    function init(root) {
      if (root.dataset.szqReady) return;
      root.dataset.szqReady = '1';
      var total = 4; // Rooms, Room Details, Climate, Results
      var current = 0;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var roomsCount = 0;          // 1..6
      var roomSizes = [];          // array de string size, length = roomsCount
      var roomTypes = [];          // array de string room type, length = roomsCount
      var state = { rooms: null, climate: null };
      var meta = { extreme: false };

      var cfg = {};
      try { cfg = JSON.parse(root.querySelector('[data-szq-config]').textContent); } catch (e) {}
      var products = [];
      try { products = JSON.parse(root.querySelector('[data-szq-products]').textContent); } catch (e) {}

      // ---- normalizare tolerant (®/™, dash-uri unicode, spatii, case) ----
      function norm(s) {
        return String(s == null ? '' : s).toLowerCase().replace(/[®™]/g, '').replace(/[‐-―]/g, '-').replace(/\s+/g, ' ').trim();
      }
      function listIncludes(arr, val) { if (!arr || !arr.length) return false; var n = norm(val); return arr.some(function (x) { return norm(x) === n; }); }
      function tHas(p, s) { return norm(p.title).indexOf(norm(s)) > -1; }
      function isCondenser(p) { return tHas(p, 'condenser'); }
      function isEasyPro(p) { return tHas(p, 'easypro') || tHas(p, 'easy pro'); }
      function isHyperHeat(p) { return norm(p.series).indexOf('hyper heat') > -1 || tHas(p, 'hyper heat'); }
      function hasZone(p, z) { return listIncludes(p.zones, z); }
      function hasBtu(p, b) { return listIncludes(p.btu, b); }

      // ---- matching ----
      function findSingle(btu, kind) {
        // kind: 'diy' | 'easypro' | 'hyper'
        return products.filter(function (p) {
          if (!hasZone(p, 'Single Zone') || !hasBtu(p, btu) || isCondenser(p)) return false;
          if (kind === 'easypro') return isEasyPro(p);
          if (kind === 'hyper') return isHyperHeat(p);
          return !isEasyPro(p) && !isHyperHeat(p); // diy 5th gen pur
        })[0] || null;
      }
      function firstNum(arr) { if (!arr || !arr.length) return 0; var m = String(arr[0]).match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
      function zoneNum(p) { return firstNum(p.zones); }   // "5 Zone" -> 5
      function capK(p) { return firstNum(p.btu); }        // "36k" -> 36
      // Cel mai mic sistem complet DIY multi-zone cu EXACT N zone si capacitate >= totalK.
      function pickMultiZone(n, totalK) {
        return products.filter(function (p) {
          return !isCondenser(p) && !isEasyPro(p) && zoneNum(p) === n && n >= 2 && capK(p) >= totalK;
        }).sort(function (a, b) { return capK(a) - capK(b); })[0] || null;
      }
      // Returneaza { best, budget, custom, mix, includesCount } pe baza raspunsurilor.
      function computeResult() {
        var out = { best: null, budget: null, custom: false, mix: [], zones: roomsCount };
        if (roomsCount === 1) {
          var s = sizeInfo(roomSizes[0]);
          if (!s) { out.custom = true; return out; }
          out.mix = [{ btu: s.btu, type: roomTypes[0] || '' }];
          if (meta.extreme) {
            out.best = findSingle(s.btu, 'hyper');
            if (!out.best) { out.custom = true; out.customMsg = 'room'; } // 9k/24k/36k nu au Hyper Heat DIY
          } else {
            out.best = findSingle(s.btu, 'diy');
            out.budget = findSingle(s.btu, 'easypro'); // doar 9k/12k exista
            if (!out.best) { out.custom = true; out.customMsg = 'room'; }
          }
          return out;
        }
        // 2-6 camere (DIY Multi-Zone) — reguli client
        out.mix = roomSizes.map(function (v, i) { var si = sizeInfo(v); return { btu: si ? si.btu : '?', type: roomTypes[i] || '' }; });
        var perK = roomSizes.map(function (v) { var si = sizeInfo(v); return si ? si.k : 0; });
        // O camera care cere > 24K (adica 36K) nu se poate face din air handlere multi-zone standard.
        if (perK.some(function (k) { return k > MULTI_HANDLER_MAX; })) { out.custom = true; out.customMsg = 'room'; return out; }
        var totalK = perK.reduce(function (a, b) { return a + b; }, 0);
        // Peste capacitatea celui mai mare condenser (55K) -> custom.
        if (totalK > MULTI_MAX_K) { out.custom = true; out.customMsg = 'combo'; return out; }
        out.best = pickMultiZone(roomsCount, totalK);
        if (!out.best) { out.custom = true; out.customMsg = 'combo'; }
        return out;
      }

      // ---- DOM refs ----
      var colAll = root.dataset.colAll || '/collections/all';
      var panels = root.querySelectorAll('[data-szq-panel]');
      var steps = root.querySelectorAll('[data-szq-step]');
      var backBtn = root.querySelector('[data-szq-back]');
      var nextBtn = root.querySelector('[data-szq-next]');
      var recEl = root.querySelector('[data-szq-rec]');
      var recTitle = root.querySelector('[data-szq-rec-title]');
      var recSub = root.querySelector('[data-szq-rec-sub]');
      var roomsWrap = root.querySelector('[data-szq-rooms]');
      var featuredHTML = recEl ? recEl.innerHTML : '';

      // ---- persistenta (contact form reincarca pagina) ----
      var storeKey = 'szq:' + (root.dataset.sectionId || '0');
      function persist() {
        try { sessionStorage.setItem(storeKey, JSON.stringify({ roomsCount: roomsCount, roomSizes: roomSizes, roomTypes: roomTypes, state: state, meta: meta, current: current })); } catch (e) {}
      }
      function restore() {
        var d; try { d = JSON.parse(sessionStorage.getItem(storeKey)); } catch (e) { return null; }
        if (!d || !d.roomsCount) return null;
        roomsCount = d.roomsCount; roomSizes = d.roomSizes || []; roomTypes = d.roomTypes || []; state = d.state || state; meta = d.meta || meta;
        // marcheaza butonul de camere
        root.querySelectorAll('[data-szq-select="rooms"]').forEach(function (b) { b.classList.toggle('is-selected', parseInt(b.dataset.count, 10) === roomsCount); });
        root.querySelectorAll('[data-szq-select="climate"]').forEach(function (b) { b.classList.toggle('is-selected', b.dataset.value === state.climate); });
        renderRoomInputs();
        return d;
      }

      // ---- pagina 2: dropdown custom per camera (Room Type + Approx Size) ----
      function ddOptions(field, current) {
        var arr = field === 'type' ? TYPES : SIZES.map(function (s) { return s.v; });
        return arr.map(function (v) {
          var isSel = current === v;
          return '<li class="szq__dd-opt' + (isSel ? ' is-selected' : '') + '" role="option" aria-selected="' + (isSel ? 'true' : 'false') + '" data-value="' + v + '">' + v + '</li>';
        }).join('');
      }
      function ddField(i, field, label, placeholder, current) {
        return '<div class="szq__room-field"><span class="szq__room-fieldlabel">' + label + '</span>' +
          '<div class="szq__dd" data-szq-dd data-index="' + i + '" data-field="' + field + '">' +
          '<button type="button" class="szq__dd-toggle" aria-haspopup="listbox" aria-expanded="false" aria-label="Room ' + (i + 1) + ' ' + label + '">' +
          '<span class="szq__dd-value' + (current ? '' : ' szq__dd-value--ph') + '">' + (current || placeholder) + '</span>' +
          '<svg class="szq__dd-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
          '</button>' +
          '<ul class="szq__dd-list" role="listbox" hidden>' + ddOptions(field, current) + '</ul>' +
          '</div></div>';
      }
      function renderRoomInputs() {
        if (!roomsWrap) return;
        var html = '';
        for (var i = 0; i < roomsCount; i++) {
          html += '<div class="szq__room">' +
            '<div class="szq__room-head"><span class="szq__room-num">' + (i + 1) + '</span><span class="szq__room-name">Room ' + (i + 1) + '</span></div>' +
            ddField(i, 'type', 'Room Type', 'Select type…', roomTypes[i] || '') +
            ddField(i, 'size', 'Approx. size', 'Select size…', roomSizes[i] || '') +
            '</div>';
        }
        roomsWrap.innerHTML = html;
      }
      function closeAllDD(except) {
        if (!roomsWrap) return;
        roomsWrap.querySelectorAll('[data-szq-dd]').forEach(function (dd) {
          if (dd === except) return;
          dd.classList.remove('is-open');
          var t = dd.querySelector('.szq__dd-toggle'); if (t) t.setAttribute('aria-expanded', 'false');
          var l = dd.querySelector('.szq__dd-list'); if (l) l.hidden = true;
        });
      }
      if (roomsWrap) {
        roomsWrap.addEventListener('click', function (e) {
          var toggle = e.target.closest('.szq__dd-toggle');
          if (toggle) {
            var dd = toggle.closest('[data-szq-dd]');
            var willOpen = !dd.classList.contains('is-open');
            closeAllDD(dd);
            dd.classList.toggle('is-open', willOpen);
            toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            dd.querySelector('.szq__dd-list').hidden = !willOpen;
            return;
          }
          var opt = e.target.closest('.szq__dd-opt');
          if (opt) {
            var dd2 = opt.closest('[data-szq-dd]');
            var idx = parseInt(dd2.dataset.index, 10);
            if (dd2.dataset.field === 'type') roomTypes[idx] = opt.dataset.value;
            else roomSizes[idx] = opt.dataset.value;
            var valEl = dd2.querySelector('.szq__dd-value');
            valEl.textContent = opt.dataset.value; valEl.classList.remove('szq__dd-value--ph');
            dd2.querySelectorAll('.szq__dd-opt').forEach(function (o) { var s = o === opt; o.classList.toggle('is-selected', s); o.setAttribute('aria-selected', s ? 'true' : 'false'); });
            closeAllDD(null);
            persist();
          }
        });
        document.addEventListener('click', function (e) { if (!roomsWrap.contains(e.target)) closeAllDD(null); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllDD(null); });
      }

      // ---- sidebar ----
      function selRows() {
        var rows = '<li><span class="szq__sel-label">Rooms</span><b>' + (roomsCount ? roomsCount + (roomsCount === 1 ? ' room' : ' rooms') : '<em class="szq__sel-pending">—</em>') + '</b></li>';
        for (var i = 0; i < roomsCount; i++) {
          var rv = roomSizes[i] ? ((roomTypes[i] ? roomTypes[i] + ' · ' : '') + roomSizes[i]) : '<em class="szq__sel-pending">—</em>';
          rows += '<li><span class="szq__sel-label">Room ' + (i + 1) + '</span><b>' + rv + '</b></li>';
        }
        rows += '<li><span class="szq__sel-label">Climate</span><b>' + (state.climate || '<em class="szq__sel-pending">—</em>') + '</b></li>';
        return rows;
      }
      function renderSidebar(index) {
        if (!recEl) return;
        var isResult = (index === total - 1);
        if (index === 0) {
          recTitle.textContent = (cfg.s1BannerTitle) || "Let's find your perfect match";
          recSub.textContent = (cfg.s1BannerSub) || 'Answer a few quick questions below.';
          recEl.innerHTML = featuredHTML;
        } else {
          recTitle.textContent = isResult ? (cfg.resultBannerTitle || 'Your Selections') : (cfg.selectionsTitle || 'Your Selections');
          recSub.textContent = isResult ? (cfg.resultBannerSub || "Here's a quick recap of your answers.") : (cfg.selectionsSub || "You're on the right track.");
          recEl.innerHTML = '<ul class="szq__sel">' + selRows() + '</ul>';
        }
        recEl.style.animation = 'none'; void recEl.offsetWidth; recEl.style.animation = 'szq-recfade .35s ease';
        // toggle email + support doar pe results
        var lead = root.querySelector('[data-szq-lead]'); if (lead) lead.hidden = !isResult;
        var help = root.querySelector('[data-szq-help-card]'); if (help) help.hidden = !isResult;
      }

      // ---- results ----
      function specMix(mix) {
        if (!mix || !mix.length) return '';
        return '<div class="szq__mix"><strong class="szq__mix-title">' + (cfg.mixTitle || 'Suggested indoor unit mix') + '</strong><ul class="szq__mix-list">' +
          mix.map(function (m, i) { return '<li><span class="szq__mix-btu">' + String(m.btu).toUpperCase() + '</span><span class="szq__mix-room">' + (m.type ? m.type + ' · ' : '') + 'Room ' + (i + 1) + '</span></li>'; }).join('') +
          '</ul></div>';
      }
      function includesHTML(n) {
        var items = [
          '1 Outdoor Condenser',
          n + (n === 1 ? ' Indoor Wall Mount Air Handler' : ' Indoor Wall Mount Air Handlers'),
          n + (n === 1 ? ' Pre-Charged Line Set' : ' Pre-Charged Line Sets'),
          'All Required Cables & Accessories',
          'DIY Installation Guide & Support'
        ];
        return '<div class="szq__includes"><strong class="szq__includes-title">' + (cfg.includesTitle || 'Complete System Includes') + '</strong><ul class="szq__includes-list">' +
          items.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul></div>';
      }
      function whyHTML() {
        var pts = (cfg.whyPoints && cfg.whyPoints.length) ? cfg.whyPoints : [
          'Perfect capacity for your room sizes and climate',
          'Independent comfort control in each room',
          'High efficiency heating & cooling year-round',
          'DIY-friendly installation with pre-charged line sets'
        ];
        return '<div class="szq__whyfit"><strong class="szq__whyfit-title">' + (cfg.whyFitTitle || 'Why this system is the best fit') + '</strong><ul class="szq__whyfit-list">' +
          pts.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul></div>';
      }
      function bestCardHTML(p, n, mix, badge, badgeClass) {
        var img = p.image ? '<img class="szq__reccard-img" src="' + p.image + '" alt="" loading="lazy">' : '';
        return '<article class="szq__reccard is-best">' +
          '<span class="szq__reccard-badge szq__reccard-badge--' + badgeClass + '">' + badge + '</span>' +
          '<div class="szq__reccard-top">' +
          '<div class="szq__reccard-media">' + img + '</div>' +
          '<div class="szq__reccard-main"><h4 class="szq__reccard-title">' + p.title + '</h4>' +
          specMix(mix) + '</div></div>' +
          includesHTML(n) + whyHTML() +
          '<div class="szq__reccard-buy">' +
          (p.price ? '<span class="szq__reccard-price">' + p.price + '</span>' : '') +
          '<a class="hero__button hero__button--primary szq__reccard-btn" href="' + p.url + '"><span>View Product</span></a>' +
          '</div></article>';
      }
      function budgetCardHTML(p) {
        var img = p.image ? '<img class="szq__reccard-img" src="' + p.image + '" alt="" loading="lazy">' : '';
        return '<article class="szq__reccard szq__reccard--budget">' +
          '<span class="szq__reccard-badge szq__reccard-badge--blue">' + (cfg.budgetBadge || 'Budget-Friendly Option') + '</span>' +
          '<div class="szq__reccard-top">' +
          '<div class="szq__reccard-media">' + img + '</div>' +
          '<div class="szq__reccard-main"><h4 class="szq__reccard-title">' + p.title + '</h4></div></div>' +
          '<div class="szq__reccard-buy">' +
          (p.price ? '<span class="szq__reccard-price">' + p.price + '</span>' : '') +
          '<a class="hero__button hero__button--secondary szq__reccard-btn" href="' + p.url + '"><span>View Product</span></a>' +
          '</div></article>';
      }
      function customCardHTML(r) {
        var combo = r && r.customMsg === 'combo';
        var text = combo
          ? (cfg.customTextCombo || 'Your room combination may need a custom multi-zone setup. Please contact our sizing team so we can help match the correct MRCOOL® system to your home.')
          : (cfg.customTextRoom || 'Your room may need a custom sizing recommendation. Please contact our sizing team so we can help match the correct MRCOOL® system to your home.');
        return '<article class="szq__custom">' +
          '<span class="szq__custom-badge">' + (cfg.customBadge || 'Custom Recommendation') + '</span>' +
          '<h4 class="szq__custom-title">' + (cfg.customTitle || 'A custom setup for your home') + '</h4>' +
          '<p class="szq__custom-text">' + text + '</p>' +
          specMix(r ? r.mix : []) +
          '<a class="hero__button hero__button--primary szq__custom-btn" href="#szq-email-' + (root.dataset.sectionId || '0') + '"><span>' + (cfg.emailBtn || 'Email My Recommendation') + '</span></a>' +
          '</article>';
      }
      function renderResults() {
        var r = computeResult();
        var recs = root.querySelector('[data-szq-recs]');
        var noteEl = root.querySelector('[data-szq-extreme-note]');
        if (noteEl) noteEl.hidden = !meta.extreme;
        if (recs) {
          var html = '';
          if (r.custom) {
            html = customCardHTML(r);
          } else if (r.best) {
            var badge = cfg.bestBadge || 'Best Match';
            html = bestCardHTML(r.best, r.zones, r.mix, badge, 'green');
            if (r.budget) html += budgetCardHTML(r.budget);
          } else {
            html = customCardHTML(r);
          }
          recs.innerHTML = html;
        }
        // populeaza rezumatul in formularul de email
        var lead = root.querySelector('[data-szq-leadbody]');
        if (lead) lead.value = leadSummary(r);
      }
      function leadSummary(r) {
        var rows = ['Rooms: ' + roomsCount];
        roomSizes.forEach(function (v, i) { rows.push('Room ' + (i + 1) + ' (' + (roomTypes[i] || '—') + '): ' + v + ' (' + (sizeInfo(v) ? sizeInfo(v).btu.toUpperCase() : '?') + ')'); });
        rows.push('Climate: ' + (state.climate || '—'));
        if (r && r.best) rows.push('Recommended: ' + r.best.title);
        else if (r && r.custom) rows.push('Recommended: Custom recommendation (needs confirmation)');
        return rows.join('\n');
      }

      // ---- navigare ----
      function goTo(index) {
        if (index < 0 || index > total - 1) return;
        var dir = index >= current ? 'szq-in-next' : 'szq-in-prev';
        current = index;
        if (index === 1) renderRoomInputs();
        panels.forEach(function (pn) { pn.classList.toggle('is-active', parseInt(pn.dataset.szqPanel, 10) === index); });
        var active = root.querySelector('[data-szq-panel="' + index + '"]');
        if (active) { active.style.animation = 'none'; void active.offsetWidth; active.style.animation = dir + ' .45s cubic-bezier(.22,1,.36,1)'; }
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); s.classList.toggle('is-done', i < index); });
        if (backBtn) backBtn.hidden = index === 0;
        if (nextBtn) nextBtn.hidden = (index >= total - 1);
        renderSidebar(index);
        if (index === total - 1) renderResults();
        persist();
      }

      // ---- validare per pas ----
      function stepValid(index) {
        if (index === 0) return !!roomsCount;
        if (index === 1) {
          if (!roomsCount) return false;
          for (var i = 0; i < roomsCount; i++) { if (!roomSizes[i] || !roomTypes[i]) return false; }
          return true;
        }
        if (index === 2) return !!state.climate;
        return true;
      }

      // ---- handlers ----
      function selectRooms(btn) {
        roomsCount = parseInt(btn.dataset.count, 10) || 0;
        state.rooms = btn.dataset.value;
        roomSizes = roomSizes.slice(0, roomsCount);
        roomTypes = roomTypes.slice(0, roomsCount);
        root.querySelectorAll('[data-szq-select="rooms"]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (current >= 1) renderSidebar(current);
        persist();
      }
      function selectClimate(btn) {
        state.climate = btn.dataset.value;
        meta.extreme = btn.dataset.extreme === 'true';
        root.querySelectorAll('[data-szq-select="climate"]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (current >= 1) renderSidebar(current);
        persist();
      }
      root.querySelectorAll('[data-szq-select="rooms"]').forEach(function (b) { b.addEventListener('click', function () { selectRooms(b); }); });
      root.querySelectorAll('[data-szq-select="climate"]').forEach(function (b) { b.addEventListener('click', function () { selectClimate(b); }); });

      if (backBtn) backBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (!stepValid(current)) { nextBtn.classList.add('szq__next--nudge'); setTimeout(function () { nextBtn.classList.remove('szq__next--nudge'); }, 400); return; }
        goTo(current + 1);
      });

      function doRestart() {
        roomsCount = 0; roomSizes = []; roomTypes = []; state = { rooms: null, climate: null }; meta = { extreme: false };
        try { sessionStorage.removeItem(storeKey); } catch (e) {}
        root.querySelectorAll('.szq__opt.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
        steps.forEach(function (s) { s.classList.remove('is-done', 'is-active'); });
        if (roomsWrap) roomsWrap.innerHTML = '';
        goTo(0);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      root.addEventListener('click', function (e) { if (e.target.closest('[data-szq-restart]')) { e.preventDefault(); doRestart(); } });

      if (root.querySelector('.szq__lead-done') || root.querySelector('.szq__form-error')) { restore(); goTo(total - 1); }
      else { var saved = restore(); goTo(saved && saved.current ? saved.current : 0); }
    }

    function boot() { document.querySelectorAll('.szq').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();
